import React, { useId } from 'react';
import { motion } from 'motion/react';
import { Link, NavLink } from 'react-router-dom';
import styles from './Menu.module.css';
import { useAuth } from '../../../../context/authContext';
import { SPRING } from '../../../../utils/motion';

function Menu({ className = '', onNavigate }) {
  const { isAuthenticated } = useAuth();
  // Menu se monta dos veces (barra y sidebar): cada instancia necesita su propio layoutId
  const indicatorId = useId();

  const links = [
    { to: '/welcome', label: 'Inicio', end: true },
    { to: '/resultados', label: 'Resultados', end: false },
    { to: '/promociones', label: 'Promociones', end: false },
    { to: '/welcome#descarga', label: 'Descarga', hash: true },
    ...(!isAuthenticated
      ? [{ to: '/auth', label: 'Regístrate', end: false }]
      : []),
    { to: '/blog', label: 'Blog', end: false },
    { to: '/ayuda', label: 'Ayuda', end: false },
    { to: '/apuestas', label: 'Jugar', end: false },
  ];

  return (
    <nav className={`${styles.nav} ${className}`} aria-label="Principal">
      <ul className={styles.links}>
        {links.map((item) => (
          <li key={item.label}>
            {item.hash ? (
              <Link
                to={item.to}
                className={styles.link}
                onClick={() => onNavigate?.()}
              >
                {item.label}
              </Link>
            ) : (
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  [styles.link, isActive ? styles.active : '']
                    .filter(Boolean)
                    .join(' ')
                }
                onClick={() => onNavigate?.()}
              >
                {({ isActive }) => (
                  <>
                    {item.label}
                    {isActive && (
                      <motion.span
                        layoutId={`nav-indicator-${indicatorId}`}
                        className={styles.indicator}
                        transition={SPRING.bouncy}
                      />
                    )}
                  </>
                )}
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Menu;
